var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ticketBadge"},[_c('img',{staticClass:"h-5",attrs:{"src":_vm.imgTicket,"srcset":(_vm.imgTicket + " 2x")}}),_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }